import * as React from 'react';
import {Fragment} from "react";
import * as Dictionary from 'Models/Dictionary';
import * as FleetModule from 'Modules/FleetModule';
import i18n from './../../../Translations/_i18n';
import {VehicleSpeedEnum} from 'Models/EnumTypes/VehicleEnumTypes';
import { Link } from "react-router-dom";

interface CustomFilterP {
    value: any;
    onChange: Function;
    isActive: boolean;
    toggleOpen: Function;
}

interface CustomFilterS {
    selectedValues: Array<any>;
}

interface CustomSortingP {
    value: any;
    onChange: Function;
    isActive: boolean;
    iconClass?: string;
    className?: string;
}

interface CustomSortingS {
    value: 'ASCENDING' | 'DESCENDING' | '';
}

export class FiltersModel<P extends CustomFilterP, S extends CustomFilterS> extends React.Component<P, S> {
    public manageValues(elValue: any): Array<any> {
        const cloneS = [...this.state.selectedValues];
        const elementIdx = cloneS.findIndex(e => e === elValue);
        if (elementIdx !== -1) {
            cloneS.splice(elementIdx, 1);
        } else {
            cloneS.push(elValue);
        }
        this.setState({
            selectedValues: cloneS
        });

        return cloneS;
    }
}

export class SortingModel<P extends CustomSortingP, S extends {}> extends React.Component<CustomSortingP, CustomSortingS> {
}

export class CarCategoryFilter extends FiltersModel<any, any> {
    constructor(props) {
        super(props);
        this.state = {
            selectedValues: []
        };
    }

    public render() {
        const {isActive} = this.props;
        return (
            <div className="customFilter customFilter--carCategory">
                <div className={`customFilter__icon ${isActive ? 'customFilter__icon--active' : ''} icon icon--car`}
                     onClick={() => this.setState({detailsVisible: !this.state.detailsVisible})}/>
                {isActive && (
                    <div className="customFilter__popup">
                        <h4 className="customFilter__name">{i18n.t(`dictionary:carCategory`)}</h4>
                        <div className="customFilter--carCategory__wrapper">
                            {Dictionary.CarCategoryArray.map((e, i) => (
                                <div
                                    key={`${e}-${i}`}
                                    className={`customFilter--carCategory__single ${this.state.selectedValues.includes(e) ? 'customFilter--carCategory__single--active' : ''}`}
                                    onClick={() => {
                                        const selectedValues = this.manageValues(e);
                                        this.props.onChange(selectedValues);
                                    }}
                                >
                                    <img src={Dictionary.CarCategoryTableFilters.get(e)} alt=""/>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export class CarStatusFilter extends FiltersModel<any, any> {
    constructor(props) {
        super(props);
        this.state = {
            selectedValues: []
        };
    }

    public render() {
        const {isActive} = this.props;
        return (
            <div className="customFilter customFilter--carCategory">
                <div className={`customFilter__icon ${isActive ? 'customFilter__icon--active' : ''} icon icon--car`}
                     onClick={() => this.setState({detailsVisible: !this.state.detailsVisible})}/>
                {isActive && (
                    <div className="customFilter__popup">
                        <h4 className="customFilter__name">{i18n.t(`dictionary:carStatus`)}</h4>
                        <div className="customFilter--carCategory__wrapper--list">
                            {Dictionary.CarStatusArray.map((e, i) => (
                                <div
                                    key={`${e}-${i}`}
                                    className={`customFilter--carCategory__single--list ${this.state.selectedValues.includes(e) ? 'active' : ''}`}
                                    onClick={() => {
                                        const selectedValues = this.manageValues(e);
                                        this.props.onChange(selectedValues);
                                    }}
                                >
                                    <img src={Dictionary.CarStatusTableFilters.get(e)} alt=""/>
                                    <span>{i18n.t(`dictionary:${e}`)}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export class CustomSort extends SortingModel<any, any> {
    constructor(props) {
        super(props);
        this.state = {
            value: ''
        };
    }

    private onChangeAction() {
        const val = this.state.value === '' || this.state.value === 'ASCENDING' ? 'DESCENDING' : 'ASCENDING';
        this.props.onChange(val);
        this.setState({
            value: val
        });
    }

    public render() {
        const {isActive} = this.props;
        return (
            <div className={`filter__sort ${this.props.className ? this.props.className : ''}`}>
                {isActive && this.state.value !== '' ? (
                    <div
                        className={`filter__sort-icon ${this.state.value === 'ASCENDING' ? 'filter__sort-icon--asc' : 'filter__sort-icon--desc'}`}
                        onClick={() => {
                            this.onChangeAction();
                        }}
                    />
                ) : (
                    <div className={`filter__sort-icon filter__sort-icon--none ${this.props.iconClass ? this.props.iconClass : ''}`}
                        onClick={() => {
                            this.onChangeAction();
                        }}
                    />
                )}
            </div>
        );
    }
}

interface CarStatusAndCategoryFilteringS extends CustomFilterS {
    multipleValues: {
        carCategory: Array<any>;
        speedLimitExceedance: Array<any>;
    };
}

interface CarStatusAndCategoryFilteringP extends CustomFilterP {
    listBelow?: boolean;
}

export class CarStatusAndCategoryFiltering extends FiltersModel<CarStatusAndCategoryFilteringP, CarStatusAndCategoryFilteringS> {
    constructor(props) {
        super(props);
        this.state = {
            selectedValues: [],
            multipleValues: {
                carCategory: [],
                speedLimitExceedance: []
            }
        };
        this.manageMultipleValues = this.manageMultipleValues.bind(this);
        this.resetValues = this.resetValues.bind(this);
    }

    private manageMultipleValues(value: any, type: 'category' | 'status') {
        const carCategory = [...this.state.multipleValues.carCategory];
        const speedLimitExceedance = [...this.state.multipleValues.speedLimitExceedance];

        if (type === 'category') {
            const elementIdx = carCategory.findIndex(e => e === value);
            if (elementIdx !== -1) {
                carCategory.splice(elementIdx, 1);
            } else {
                carCategory.push(value);
            }
        } else {
            const elementIdx = speedLimitExceedance.findIndex(e => e === value);
            if (elementIdx !== -1) {
                speedLimitExceedance.splice(elementIdx, 1);
            } else {
                speedLimitExceedance.push(value);
            }
        }
        const multipleValues = {
            carCategory,
            speedLimitExceedance
        };

        this.setState({
            multipleValues
        });
        this.props.onChange(multipleValues);
    }

    public resetValues() {
        const initialValues = {
            carCategory: [],
            speedLimitExceedance: []
        };
        this.setState({multipleValues: initialValues});
        this.props.onChange(initialValues);
    }

    public render() {
        const {isActive, toggleOpen} = this.props;
        const hasValue = this.state.multipleValues.carCategory.length > 0 || this.state.multipleValues.speedLimitExceedance.length > 0;
        return (
            <div className={`customFilter customFilter--carCategory ${this.props.listBelow ? 'listBelow' : ''}`}>
                <div
                    className={`customFilter__icon--wrapper${hasValue ? ' customFilter__icon--wrapper_has-value' : ''}`}>
                    <div className={`customFilter__icon ${isActive ? 'customFilter__icon--active' : ''} icon icon--car`}
                         onClick={() => toggleOpen()}/>
                    <div
                        className={`customFilter__icon-resetFilters ${hasValue ? 'customFilter__icon-resetFilters--expanded' : ''} `}
                        onClick={this.resetValues}/>
                </div>
                {isActive && (
                    <div className="customFilter__popup">
                        <h4 className="customFilter__name">{i18n.t(`dictionary:carCategory`)}</h4>
                        <div className="customFilter--carCategory__wrapper">
                            {Dictionary.CarCategoryArray.map((e, i) => (
                                <div
                                    key={`${e}-${i}`}
                                    className={`customFilter--carCategory__single ${this.state.multipleValues.carCategory.includes(e) ? 'customFilter--carCategory__single--active' : ''}`}
                                    onClick={() => {
                                        this.manageMultipleValues(e, 'category');
                                    }}
                                >
                                    <img src={Dictionary.CarCategoryTableFilters.get(e)} alt=""/>
                                </div>
                            ))}
                        </div>
                        <h4 className="customFilter__name">{i18n.t(`dictionary:carStatus`)}</h4>
                        <div className="customFilter--carCategory__wrapper--list">
                            {Dictionary.CarStatusArray.map((e, i) => (
                                <div
                                    key={`${e}-${i}`}
                                    className={`customFilter--carCategory__single--list ${this.state.multipleValues.speedLimitExceedance.includes(e) ? 'active' : ''}`}
                                    onClick={() => {
                                        this.manageMultipleValues(e, 'status');
                                    }}
                                >
                                    <img src={Dictionary.CarStatusTableFilters.get(e)} alt=""/>
                                    <span>{i18n.t(`dictionary:${e}`)}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

interface CarFleetFilteringP extends CustomFilterP {
    fleetList: Array<FleetModule.Types.CarFleetSimpleDto>;
}

export class CarFleetFiltering extends FiltersModel<CarFleetFilteringP, any> {
    constructor(props) {
        super(props);
        this.state = {
            selectedValues: []
        };
    }

    public render() {
        const {isActive, toggleOpen} = this.props;
        const hasValue = this.state.selectedValues.length > 0;
        return (
            <div className="customFilter customFilter--carCategory customFilter--fleet">
                <div
                    className={`customFilter__icon--wrapper${hasValue ? ' customFilter__icon--wrapper_has-value' : ''}`}>
                    <div
                        className={`customFilter__icon ${isActive ? 'customFilter__icon--active' : ''} icon icon--fleet`}
                        onClick={() => toggleOpen()}/>
                    <div
                        className={`customFilter__icon-resetFilters ${hasValue ? 'customFilter__icon-resetFilters--expanded' : ''} `}
                        onClick={() => {
                            this.setState({selectedValues: []});
                            this.props.onChange([]);
                        }}
                    />
                </div>
                {isActive && (
                    <div className="customFilter__popup">
                        <h4 className="customFilter__name">{i18n.t(`dictionary:fleet`)}</h4>
                        <div className="customFilter--carCategory__wrapper--list">
                            {this.props.fleetList.map((e, i) => {
                                try {
                                    return (
                                        <div
                                            key={`${e}-${i}`}
                                            className={`customFilter--carCategory__single--list ${this.state.selectedValues.includes(e.id) ? 'active' : ''}`}
                                            onClick={() => {
                                                const selectedValues = this.manageValues(e.id);
                                                this.props.onChange(selectedValues);
                                            }}
                                        >
                                            <span
                                                className="bold customFilter--carCategory__numberOfCars">{e.numberOfCars}</span>{' '}
                                            <img src={Dictionary.CarStatusTableFilters.get(VehicleSpeedEnum.GREY)}
                                                 alt=""/> <span>{e.name}</span>
                                        </div>
                                    )
                                } catch (e) {
                                    // do nothing
                                }
                            })}
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

enum FleetCellTooltip {
    TOP = 'TOP',
    BOTTOM = 'BOTTOM',
    NONE = 'NONE'
}

interface IFleetCellProps {
  cellInfo: any;
  onFleetClick?: (id: number) => void
}

interface IFleetCellState {
  subMenuVisible: FleetCellTooltip;
}

export class FleetCell extends React.Component<IFleetCellProps, IFleetCellState> {
    constructor(props) {
        super(props);
        this.state = {
            subMenuVisible: FleetCellTooltip.NONE
        };

        this.showSubMenu = this.showSubMenu.bind(this);
    }

    public showSubMenu(a) {
        const differenceHeight = window.innerHeight - a.pageY;

        this.setState({
            subMenuVisible: (differenceHeight < 150) ? FleetCellTooltip.TOP : FleetCellTooltip.BOTTOM
        });
    }

    public renderFleetButtons(fleets: FleetModule.Types.CarFleetSimpleDto[]) {
      const onlyExistedFleets = fleets
        .filter((fleet) => fleet);

      return onlyExistedFleets
        // @ts-ignore
        .map(({ name, id} = {}, index) => (
          <Fragment key={id}>
            <Link to={`/fleet/${id}`}>{name}</Link>
            {index < onlyExistedFleets.length - 1 ? ' | ' : ''}
          </Fragment>
        ))
    }

    // TODO: refactor styli
    public render() {
        const carFleets = this.props.cellInfo.value;
        if (!carFleets?.length || carFleets.length === 0) {
            return null
        }

        return (
            <div className="fleetCell">
                <div className="fleetCell__button" onMouseEnter={this.showSubMenu}
                     onMouseLeave={() => this.setState({subMenuVisible: FleetCellTooltip.NONE})}>
                    <div className={`customFilter__icon icon icon--fleet`}/>
                    {this.state.subMenuVisible == FleetCellTooltip.BOTTOM && (
                        <div className="fleetCell__popup customFilter--carCategory__wrapper--list">
                            {carFleets.map((e, i) => {
                                try {
                                    return (
                                        <div key={`${e.name}-${i}-v2`}
                                             className={`customFilter--carCategory__single--list`}>
                                            <span
                                                className="bold customFilter--carCategory__numberOfCars">{e.numberOfCars}</span>{' '}
                                            <img src={Dictionary.CarStatusTableFilters.get(VehicleSpeedEnum.GREY)}
                                                 alt=""/> <span>{e.name}</span>
                                        </div>
                                    )
                                } catch (e) {
                                    //do nothing
                                }
                            })}
                        </div>
                    )}

                    {this.state.subMenuVisible == FleetCellTooltip.TOP && (
                            <div
                                className="fleetCell__popup fleetCell__popup--top customFilter--carCategory__wrapper--list">
                                {carFleets.map((e, i) => {
                                    try {
                                        return (
                                            <div key={`${e}-${i}-v2`}
                                                 className={`customFilter--carCategory__single--list`}>
                                                <span
                                                    className="bold customFilter--carCategory__numberOfCars">{e.numberOfCars}</span>{' '}
                                                <img
                                                    src={Dictionary.CarStatusTableFilters.get(VehicleSpeedEnum.GREY)}
                                                    alt=""/> <span>{e.name}</span>
                                            </div>
                                        )
                                    } catch (e) {
                                        //do nothing
                                    }
                                })}
                        </div>
                    )}
                </div>
                <div className="fleetCell__text">
                  {this.renderFleetButtons(carFleets)}
                </div>
            </div>
        );
    }
}

// const FleetCellWithRouter = withRouter(FleetCell)
//
// export {
//   FleetCellWithRouter as FleetCell,
// }



// WEBPACK FOOTER //
// ./src/components/Map/VehiclesList/CustomFilterComponents.tsx